export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This tutorial has been updated. ` + `Reload to display the latest version?`
  );

  if (answer === true) {
    window.location.reload();
  }
};

// Every content page uses the same docs.js template, so Gatsby's client-side
// router updates that one instance in place on navigation rather than
// mounting a new one - Layout (and the sidebar inside it) never re-renders
// on its own as a result, and any location-derived state inside it (the
// active-page highlight, which section should show as expanded) goes stale
// after the first page load. onRouteUpdate is the one thing guaranteed to
// fire on every navigation regardless, so the sidebar listens for this
// event instead of trusting a location prop or reading document.location
// mid-render. See src/components/sidebar/tree.js.
export const onRouteUpdate = ({ location }) => {
  window.dispatchEvent(new CustomEvent('gatsby-route-update', { detail: { location } }));
};
